import { ZollAPIService } from '../../../services/zollApi.service'
import { zollBaseURL } from '../../../services/api.service'
import { APIError, SubmitChartResponse } from '../store/submitChart.types'
import Logger from '../../../services/logger.service'

const submitChartUrl = `${zollBaseURL}/api/DataMapping/pcr-to-oracle`
const fetchPRIDUrl = `${zollBaseURL}/api/DatabaseAmb/prid`

export class SubmitChartService extends ZollAPIService {
  async doSubmitChart(data: string | unknown): Promise<SubmitChartResponse> {
    return this.postWithError(submitChartUrl, data)
  }

  async fetchPRID() {
    return this.get(fetchPRIDUrl)
  }

  static createErrorResponse(responseMessage: string): SubmitChartResponse {
    const response: SubmitChartResponse = {
      success: false,
      failure: true,
      responseMessage,
    }

    return response
  }

  static printOracleStatements(response: SubmitChartResponse) {
    if (response && response.oracleStatements) {
      let oracleStatementsLog = '\n'
      oracleStatementsLog += '----------------------------------\n'
      oracleStatementsLog += 'START: Oracle Statements\n'
      oracleStatementsLog += '----------------------------------\n'

      response.oracleStatements.forEach((os) => {
        oracleStatementsLog += os + '\n\n'
      })

      oracleStatementsLog += '----------------------------------\n'
      oracleStatementsLog += 'END: Oracle Statements\n'
      oracleStatementsLog += '----------------------------------'

      Logger.sensitive(oracleStatementsLog, 'Oracle Statements from SubmitChartResponse')
    }
  }

  static printAPIError(error: APIError) {
    console.log('----------------------------------')
    console.log('START: APIError')
    console.log('----------------------------------')

    SubmitChartService.printAPIErrorInner(error, 1)

    console.log('----------------------------------')
    console.log('END: APIError')
    console.log('----------------------------------')
  }

  private static printAPIErrorInner(error: APIError, errorNumber: number) {
    console.log('-----------------')
    console.log(`Error number: ${errorNumber}`)
    console.log('-----------------')

    Logger.sensitive(`${error.message}`, 'Error message')

    console.log(`Error stackTrace: ${error.stackTrace ? error.stackTrace : 'none'}`)

    if (!error.cause) {
      console.log('Error cause: none')
    } else {
      SubmitChartService.printAPIErrorInner(error.cause, errorNumber + 1)
    }
  }
}
